"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.creativeWorkTaggingMachineCan = exports.creativeWorkTaggingMachineTransition = exports.machine = exports.CREATIVE_WORK_STATES_QA = exports.CREATIVE_WORK_STATES = exports.CREATIVE_WORK_PUBLISHED = exports.CREATIVE_WORK_PUBLISH_ERROR = exports.CREATIVE_WORK_PUBLISH_COMPLETED = exports.CREATIVE_WORK_PUBLISH_STARTED = exports.CREATIVE_WORK_QA_PAUSED = exports.CREATIVE_WORK_QA_STARTED = exports.CREATIVE_WORK_QA_ASSIGNED = exports.CREATIVE_WORK_QA_AVAILABLE = exports.CREATIVE_WORK_TAGGING_PAUSED = exports.CREATIVE_WORK_TAGGING_STARTED = exports.CREATIVE_WORK_TAGGING_ASSIGNED = exports.CREATIVE_WORK_TAGGING_AVAILABLE = exports.CREATIVE_WORK_INITIAL = void 0;
const user_1 = require("../../users/user");
const xstate_1 = require("xstate");
const events_1 = require("xstate-helpers/events");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const noop_1 = __importDefault(require("lodash/noop"));
exports.CREATIVE_WORK_INITIAL = '[internal] initial';
exports.CREATIVE_WORK_TAGGING_AVAILABLE = 'Tagging Available';
exports.CREATIVE_WORK_TAGGING_ASSIGNED = 'Tagging Assigned';
exports.CREATIVE_WORK_TAGGING_STARTED = 'Tagging Started';
exports.CREATIVE_WORK_TAGGING_PAUSED = 'Tagging Paused';
exports.CREATIVE_WORK_QA_AVAILABLE = 'QA Available';
exports.CREATIVE_WORK_QA_ASSIGNED = 'QA Assigned';
exports.CREATIVE_WORK_QA_STARTED = 'QA Started';
exports.CREATIVE_WORK_QA_PAUSED = 'QA Paused';
exports.CREATIVE_WORK_PUBLISH_STARTED = 'Publish Started';
exports.CREATIVE_WORK_PUBLISH_COMPLETED = 'Publish Completed';
exports.CREATIVE_WORK_PUBLISH_ERROR = 'Publish Error';
exports.CREATIVE_WORK_PUBLISHED = 'Published';
exports.CREATIVE_WORK_STATES = [
    exports.CREATIVE_WORK_INITIAL,
    exports.CREATIVE_WORK_TAGGING_AVAILABLE,
    exports.CREATIVE_WORK_TAGGING_ASSIGNED,
    exports.CREATIVE_WORK_TAGGING_STARTED,
    exports.CREATIVE_WORK_TAGGING_PAUSED,
    exports.CREATIVE_WORK_QA_AVAILABLE,
    exports.CREATIVE_WORK_QA_ASSIGNED,
    exports.CREATIVE_WORK_QA_STARTED,
    exports.CREATIVE_WORK_QA_PAUSED,
    exports.CREATIVE_WORK_PUBLISHED,
    exports.CREATIVE_WORK_PUBLISH_STARTED,
    exports.CREATIVE_WORK_PUBLISH_COMPLETED,
    exports.CREATIVE_WORK_PUBLISH_ERROR,
];
exports.CREATIVE_WORK_STATES_QA = [
    exports.CREATIVE_WORK_QA_AVAILABLE,
    exports.CREATIVE_WORK_QA_ASSIGNED,
    exports.CREATIVE_WORK_QA_STARTED,
    exports.CREATIVE_WORK_QA_PAUSED,
];
const hasAssigneeSet = (_, e) => {
    (0, events_1.invariantEvent)(e, 'CREATE');
    return !!e.data.assignee;
};
const userMatchesAssignee = ({ workflow: { assignee } }, e) => {
    (0, events_1.invariantEvent)(e, [
        'START',
        'PAUSE',
        'RESUME',
        'CONTINUE_STARTED',
        'TAGGING_COMPLETE',
        'TAGGING_ABANDON',
        'RETURN_TO_TAGGER',
        'PUBLISH_START',
        'PUBLISH_SUCCESS',
        'PUBLISH_ERROR',
    ]);
    (0, tiny_invariant_1.default)(assignee, 'Must have assignee set for the workflow');
    return e.user instanceof user_1.User
        ? assignee === e.user.id
        : assignee === e.user['relationship.employeeId'];
};
exports.machine = (0, xstate_1.createMachine)({
    initial: exports.CREATIVE_WORK_INITIAL,
    states: {
        [exports.CREATIVE_WORK_INITIAL]: {
            on: {
                CREATE: [
                    {
                        cond: 'hasAssigneeSet',
                        target: exports.CREATIVE_WORK_TAGGING_ASSIGNED,
                    },
                    {
                        target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    },
                ],
            },
        },
        [exports.CREATIVE_WORK_TAGGING_AVAILABLE]: {
            on: {
                SELF_ASSIGN: {
                    target: exports.CREATIVE_WORK_TAGGING_ASSIGNED,
                },
            },
        },
        [exports.CREATIVE_WORK_TAGGING_ASSIGNED]: {
            on: {
                TAGGING_ABANDON: {
                    target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    cond: 'userMatchesAssignee',
                },
                START: {
                    target: exports.CREATIVE_WORK_TAGGING_STARTED,
                    cond: 'userMatchesAssignee',
                },
            },
        },
        [exports.CREATIVE_WORK_TAGGING_STARTED]: {
            on: {
                TAGGING_ABANDON: {
                    target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    cond: 'userMatchesAssignee',
                },
                PAUSE: {
                    target: exports.CREATIVE_WORK_TAGGING_PAUSED,
                    cond: 'userMatchesAssignee',
                },
                TAGGING_COMPLETE: {
                    target: exports.CREATIVE_WORK_QA_AVAILABLE,
                    cond: 'userMatchesAssignee',
                },
                CONTINUE_STARTED: {
                    cond: 'userMatchesAssignee',
                    actions: noop_1.default,
                },
            },
        },
        [exports.CREATIVE_WORK_TAGGING_PAUSED]: {
            on: {
                TAGGING_ABANDON: {
                    target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    cond: 'userMatchesAssignee',
                },
                RESUME: {
                    target: exports.CREATIVE_WORK_TAGGING_STARTED,
                    cond: 'userMatchesAssignee',
                },
            },
        },
        [exports.CREATIVE_WORK_QA_AVAILABLE]: {
            on: {
                SELF_ASSIGN: {
                    target: exports.CREATIVE_WORK_QA_ASSIGNED,
                },
            },
        },
        [exports.CREATIVE_WORK_QA_ASSIGNED]: {
            on: {
                START: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                    cond: 'userMatchesAssignee',
                },
            },
        },
        [exports.CREATIVE_WORK_QA_STARTED]: {
            on: {
                PAUSE: {
                    target: exports.CREATIVE_WORK_QA_PAUSED,
                    cond: 'userMatchesAssignee',
                },
                PUBLISH_START: {
                    target: exports.CREATIVE_WORK_PUBLISH_STARTED,
                    cond: 'userMatchesAssignee',
                },
                RETURN_TO_TAGGER: {
                    target: exports.CREATIVE_WORK_TAGGING_PAUSED,
                    cond: 'userMatchesAssignee',
                },
                CONTINUE_STARTED: {
                    cond: 'userMatchesAssignee',
                    // https://github.com/statelyai/xstate/issues/2825
                    actions: noop_1.default,
                },
            },
        },
        [exports.CREATIVE_WORK_QA_PAUSED]: {
            on: {
                RESUME: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                    cond: 'userMatchesAssignee',
                },
            },
        },
        [exports.CREATIVE_WORK_PUBLISH_STARTED]: {
            on: {
                PUBLISH_SUCCESS: {
                    target: exports.CREATIVE_WORK_PUBLISHED,
                    cond: 'userMatchesAssignee',
                },
                PUBLISH_ERROR: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                    cond: 'userMatchesAssignee',
                },
            },
        },
        [exports.CREATIVE_WORK_PUBLISHED]: {
            type: 'final',
        },
    },
}, {
    guards: {
        userMatchesAssignee,
        hasAssigneeSet,
    },
});
function creativeWorkTaggingMachineTransition(workflow, event) {
    return exports.machine.transition(workflow.state, event, { workflow });
}
exports.creativeWorkTaggingMachineTransition = creativeWorkTaggingMachineTransition;
function creativeWorkTaggingMachineCan(workflow, event) {
    return !!creativeWorkTaggingMachineTransition(workflow, event).changed;
}
exports.creativeWorkTaggingMachineCan = creativeWorkTaggingMachineCan;
//# sourceMappingURL=creative-work-tagging.machine.js.map